import React from "react";
import { useTranslation } from "react-i18next";

import { useTheme } from "@mui/material";
import { DangerOutlinedButton, SecondaryButton } from "@shared/CustomButton";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";

export type ActionCellProps = {
    product: API.Product;
    isDeleting: boolean;
    onDelete: (id: number) => void;
    setEditProductId: (id: number | null) => void;
    setConfigProduct: React.Dispatch<React.SetStateAction<API.Product | null>>;
};

export const ActionCell = (props: ActionCellProps) => {
    const theme = useTheme();
    const { t } = useTranslation(["pages"]);
    return (
        <MinimalTableCell align="right">
            <SecondaryButton
                style={{ marginRight: theme.spacing(1) }}
                tooltipProps={{ title: t("pages:adminProductsPage.tooltip.editProduct") }}
                onClick={() => {
                    props.setEditProductId(props.product.id);
                }}
            >
                <i className="fa-solid fa-pencil" />
            </SecondaryButton>
            <SecondaryButton
                style={{ marginRight: theme.spacing(1) }}
                tooltipProps={{ title: t("pages:adminProductsPage.tooltip.showConfig") }}
                size="small"
                onClick={() => {
                    props.setConfigProduct(props.product);
                }}
            >
                <i className="fa-solid fa-code" />
            </SecondaryButton>
            <DangerOutlinedButton onClick={() => props.onDelete(props.product.id)} loading={props.isDeleting}>
                <i className="fa-solid fa-trash" />
            </DangerOutlinedButton>
        </MinimalTableCell>
    );
};
